// eslint-disable-next-line no-unused-vars
import ProductSelection from "../../../domains2/orders/ProductSelection";
// eslint-disable-next-line no-unused-vars
export const getProductPriceWithDiscounts = (products, productSelections, productCatalog, menuSize = -1, menuWithDiscounts = false, discountTypeDisable = ["familyDiscount"]) => {

	const orderLines = ProductSelection.mapToOrderLinesGen(5)(productCatalog, productSelections, false, {}, [], true, discountTypeDisable);

	return products.reduce((acc, product) => {
		const calculateDiscount = (type) => {
			if (type === "simpleDiscountFixedAmount") {
				return product.discount.discountValue;
			}else if (type === "percentDiscount") {
				return product.price ? product.price * product.discount.discountValue / 100 : 0;
			} else {
				return 0;
			}
		};
		const discountValue = product.discount ? calculateDiscount(product.discount.discountType) : 0;
		if (product.price) {
			return {...acc, [product.id]: {
				basePrice: product.price,
				discountPrice: product.price - discountValue
			}
			};
		} else {
			const orderLine = orderLines.find(orderLine => orderLine.productId === product.id);
			return {...acc, [product.id]: {
				basePrice: orderLine.totalPriceBeforeAccum || orderLine.priceBeforeAcum,
				discountPrice: orderLine.totalPriceAccum
			}
			};
		}
	}, {});

};

export const ADJUST_SDK_EVENT_KEYS = Object.freeze({
	"PROFILE_CREATED": "nlb0oe",
	"POINTS_EARNED": "boqjus",
	"POINTS_SPENT": "tvamtr",
	"TRANSACTION_CONFIRMED": "roro4l",
	"MEMBERSHIP_CONFIRMED": "29r9sj"
});

export const SUNSET_PLUS_UPSELL_MODAL_MINIMAL_SPENDING = 165;

export const getGlobalTemplateReplaceCssName = (tenantId, replaceCss) => {
	for (const key in replaceCss) {
		if (replaceCss[key].includes(tenantId)) {
			return key;
		}
	}
	return null;
};
